import { render, staticRenderFns } from "./AFleetChatbot.vue?vue&type=template&id=e38080ba&scoped=true"
import script from "./AFleetChatbot.vue?vue&type=script&lang=js"
export * from "./AFleetChatbot.vue?vue&type=script&lang=js"
import style0 from "./AFleetChatbot.vue?vue&type=style&index=0&id=e38080ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e38080ba",
  null
  
)

export default component.exports